module.exports = __webpack_public_path__ + "static/img/XAVIER-TAYLOR.8bee86e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XAVIER-TAYLOR.jpg
// module id = igSJ
// module chunks = 0